<div class="card-inner-main-div">
  <div [ngClass]="{'card-main-title': true, 'border-bottom': showSegReport}">
    <h4 [ngClass]="{'card-title': showSegReport, 'card-title-h': !showSegReport}">{{ showSegReport ? 'Exposure' : 'Associated Sites' }}@if (showSegReport) {
      <span class="small-light-text d-block">In
      Location</span>
    }</h4>
  </div>
  <div class="tableColStyle without-borders-table">
    @if (loadingExposureDetail) {
      <div class="comments-loader">
        <img src="assets/images/loader.gif">
      </div>
    }
    @if (!loadingExposureDetail) {
      <div class="table-responsive">
        <table class="table table-striped" matSortDisableClear matSort  matSortActive="severity" matSortDirection="asc" (matSortChange)="sortSEG($event)">
          <thead>
            <tr>
              <th scope="col">
                <a>{{ 'Site' | translate }}</a>
              </th>
              @if (showSegReport) {
                <th scope="col">
                  <a>{{ 'Severity' | translate }}</a>
                </th>
              }
              @if (!showSegReport) {
                <th scope="col" mat-sort-header="workers">
                  <a>{{ 'Employees' | translate }}</a>
                </th>
              }
              @if (showSegReport) {
                <th scope="col">
                  <a>{{ 'Employees' | translate }}</a>
                </th>
              }
              @if (showSegReport) {
                <th scope="col">
                  <a>{{ 'Change' | translate }}</a>
                </th>
              }
              <th scope="col">
                <a>{{ (showSegReport ? '# of samples' : 'Annual samples') | translate }}</a>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (task of exposureDetail; track trackByIndex($index)) {
              <tr>
                <td><span [ngClass]="{'font-700' : showSegReport, 'site-font' : !showSegReport}">{{task?.orgLevelName}}</span></td>
                @if (showSegReport) {
                  <td class="green-text" [style]="{color:(task?.color?'#'+task?.color:colors.greyLight)+' !important'}">
                  {{ (task?.severity ? task.severity : 0) | number : '1.0-2'}}</td>
                }
                <td [ngClass]="{'rest-font' : !showSegReport}">{{task?.workers ? task?.workers : 0}}</td>
                @if (showSegReport) {
                  <td>
                    @if (task?.change) {
                      <b>{{ $safeNavigationMigration(task?.change) | number : '1.0-2'}}%</b>
                    }
                    @if (!task?.change) {
                      <span>-</span>
                    }
                  </td>
                }
                <td [ngClass]="{'rest-font' : !showSegReport}">{{task?.numberOfSamples ? task?.numberOfSamples : 0}}</td>
              </tr>
            }
            @if (exposureDetail && !exposureDetail.length) {
              <tr>
                <td colspan="5" class="no-data-available with-padding">{{ 'No Data Available' | translate }}</td>
              </tr>
            }
            <!-- <tr>
            <td><span class="font-700">Fording River</span></td>
            <td>2.2</td>
            <td>Pit Utility</td>
            <td>
              <div class="percentage-txt-div w-100">
                11.8%
              </div>
            </td>
            <td>6/20</td>
          </tr>
          <tr> -->
          </tbody>
        </table>
      </div>
    }
  </div>
</div>